export const ABORT_SIGNAL_NAME = {
  accountingContextRefreshAccessToken: 'accountingContext::refreshAccessToken',
  accountingContextFetchTenantInfo: 'accountingContext::fetchTenantInfo',
  accountingContextFetchAllResponsibleEmployees: 'accountingContext::fetchAllResponsibleEmployees',
};
